(() => {
  if (customElements.get('bond-frame-dimensions')) return;
  customElements.define('bond-frame-dimensions', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-unit-toggle]');
      if (!this.button) return;
      this.unit = 'mm';
      this.handleToggle = () => {
        this.unit = this.unit === 'mm' ? 'inches' : 'mm';
        this.renderUnit();
      };
      this.button.addEventListener('click', this.handleToggle);
      this.renderUnit();
      this.button.hidden = false;
    }
    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleToggle);
    }
    renderUnit() {
      const inches = this.unit === 'inches';
      this.querySelectorAll('[data-mm]').forEach((node) => {
        const mm = Number(node.dataset.mm);
        if (!Number.isFinite(mm) || mm <= 0) return;
        node.textContent = inches ? `${(mm / 25.4).toFixed(2)} in` : `${Number(mm.toFixed(1))} mm`;
      });
      this.querySelectorAll('[data-unit-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.unitPanel !== this.unit;
      });
      this.button.textContent = inches ? this.dataset.labelMm : this.dataset.labelInches;
      this.button.setAttribute('aria-pressed', String(inches));
      const status = this.querySelector('[data-unit-status]');
      if (status) status.textContent = inches ? this.dataset.statusInches : this.dataset.statusMm;
    }
  });
})();
